import { EMemberChoicesLabels } from 'affiny-core/modules/api/models/memberchoice/memberchoice.types';
import { selectQuestionsForKeys } from 'affiny-core/redux/selectors/reflistsSelectors';
import { connect } from 'react-redux';
import { IRootState } from '../../state';

interface IOwnProps {
  reflistKeys: EMemberChoicesLabels[];
}

const mapStateToProps = (state: IRootState, ownProps: IOwnProps) => ({
  questions: selectQuestionsForKeys(state, ownProps.reflistKeys),
});

export type IQuestionsContainerProps = ReturnType<typeof mapStateToProps>;

export const questionsContainerFactory = connect(mapStateToProps);
